<template >
  <v-container fluid style="height: 100%; padding: 0;"  >
    <v-layout fill-height row style="height: 100%;">
      <AdminSideBarMenu />
      <v-flex x12 class="dashboard-view">
        <v-container fluid grid-list-md mb-2 style="overflow:  hidden;">
          <v-layout row wrap justify-space-between class="number-metrics dashboard-cards">
            <v-flex xs12 sm6 lg3>
              <v-card>
                <v-card-title class="dashboard-card_title pb-1">
                  <div class="stat_title">
                    <h4 class="title">Website Traffic</h4>
                  </div>
                </v-card-title>
                <v-layout row wrap pl-4 pr-4 pt-2 pb-4>
                  <v-flex xs6>
                    <v-card class="number-metrics-item" flat>
                      <span class="metric-key">Month to Date</span>
                      <div class="pt-1">
                        <div class="title bold pr-1">{{wt1 | formatNumber}}</div>
                        <span id="traffic_percent" :class="p1c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{p1}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                  <v-flex xs6>
                    <v-card class="pl-3" flat>
                      <span class="metric-key">Year to Date</span>
                      <div class="pt-1">
                        <div class="title bold pr-1">{{wt2 | formatNumber}}</div>
                        <span :class="p2c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{p2}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 lg3>
              <v-card>
                <v-card-title class="dashboard-card_title pb-1">
                  <div class="stat_title ">
                    <h4 class="title">New Users</h4>
                  </div>
                </v-card-title>
                <v-layout row wrap pl-4 pr-4 pt-2 pb-4>
                  <v-flex xs6>
                    <v-card class="number-metrics-item" flat>
                      <span class="metric-key">Month to Date</span>
                      <div class="pt-1">
                        <div class="title bold pr-1">{{nt1 | formatNumber}}</div>
                        <span id="traffic_percent" :class="np1c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{np1}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                  <v-flex xs6>
                    <v-card class="pl-3" flat>
                      <span class="metric-key">Year to Date</span>
                      <div class="pt-1">
                        <div class="title bold pr-1">{{nt2 | formatNumber}}</div>
                        <span :class="np2c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{np2}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 lg3>
              <v-card>
                <v-card-title class="dashboard-card_title pb-1">
                  <div class="stat_title">
                    <h4 class="title">Avg. Time-on-site</h4>
                  </div>
                </v-card-title>

                <v-layout row wrap pl-4 pr-4 pt-2 pb-4>
                  <v-flex xs6>
                    <v-card class="number-metrics-item" flat>
                      <span class="metric-key">Month to Date</span>
                      <div class="pt-1">
                        <div class="title bold pr-1">{{tt1 | formatNumber}}</div>
                        <span id="traffic_percent" :class="tp1c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{tp1}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>

                  <v-flex xs6>
                    <v-card class="pl-3" flat>
                      <span class="metric-key">Year to Date</span>
                      <div class="pt-1">
                        <div class="title bold pr-1">{{tt2 | formatNumber}}</div>
                        <span :class="tp2c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{tp2}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 lg3>
              <v-card>
                <v-card-title class="dashboard-card_title pb-1">
                  <div class="stat_title">
                    <h4 class="title">Engagement (MDT)</h4>
                  </div>
                </v-card-title>
                <v-layout row wrap pl-4 pr-4 pt-2 pb-4>
                  <v-flex xs6>
                    <v-card class="number-metrics-item" flat>
                      <span class="metric-key">Post</span>
                      <div class="pt-1">
                        <div class="title bold">{{pt1 | formatNumber}}</div>
                        <span id="traffic_percent" :class="pp1c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{pp1}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                  <v-flex xs6>
                    <v-card class="pl-3" flat>
                      <span class="metric-key">Likes</span>
                      <div class="pt-1">
                        <div class="title bold pr-1">{{pt2 | formatNumber}}</div>
                        <span :class="pp2c" class="body-2">
                          <v-icon medium>mdi-menu-up</v-icon>
                          <v-icon medium>mdi-menu-down</v-icon>
                          {{pp2}}%
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid class="pa-1 mb-2">
          <v-layout row>
            <v-flex xs12>
              <chart-view></chart-view>
            </v-flex>
          </v-layout>
        </v-container>
        <block1 />
        <PageFooter />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import VueHighcharts from 'vue2-highcharts'

  import MainMenu from '../../../components/main-menu/MainMenuComponent.vue'
  import Block from './Index/block.vue'
  import Block1 from './Index/block.1.vue'
  import UserToolbar from '../../../components/Toolbar.vue'
  import AdminSideBarMenu from './Components/AdminSideBar.vue'
  import PageFooter from './Components/PageFooter.vue'
  import ChartView from './chart'

  import 'font-awesome/css/font-awesome.min.css'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    components: {
      MainMenu,
      Block,
      Block1,
      AdminSideBarMenu,
      UserToolbar,
      VueHighcharts,
      ChartView,
      PageFooter
    },
    filters: {
      formatNumber: function (value) {
        var str = value + ''
        var x = str.split('.')
        var x1 = x[0]
        var x2 = x.length > 1 ? '.' + x[1] : ''
        var rgx = /(\d+)(\d{3})/
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2')
        }
        return x1 + x2
      }
    },
    data: () => ({
      drawer: true,
      loading: false,
      h1: window.title,
      wt1: 0,
      wt2: 0,
      wt3: 0,
      wt4: 0,
      p1: 0,
      p2: 0,
      p1c: 'decline',
      p2c: 'decline',
      nt1: 0,
      nt2: 0,
      nt3: 0,
      nt4: 0,
      np1: 0,
      np2: 0,
      np1c: 'decline',
      np2c: 'decline',
      tt1: 0,
      tt2: 0,
      tt3: 0,
      tt4: 0,
      tp1: 0,
      tp2: 0,
      tp1c: 'decline',
      tp2c: 'decline',
      pt1: 0,
      pt2: 0,
      pt3: 0,
      pt4: 0,
      pp1: 0,
      pp2: 0,
      pp1c: 'decline',
      pp2c: 'decline'
    }),

    methods: {
      onDismiss () {
        this.$store.dispatch('setError', null)
        this.$store.dispatch('setProcess', 'null')
      },
      triggerDrawer () {
        this.drawer = !this.drawer
      },
      loadData () {
        let self = this
        var startDate = moment(new Date()).add(-1, 'days').subtract(30, 'days').format('YYYY-MM-DD')
        var endDate = moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        var u = '?metrics=ga:pageviews&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate + '&endDate=' + endDate
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u)
          .then((response) => {
            if (response.data.rows.length !== 0) {
              var count = 0
              response.data.rows.forEach((dateValue) => {
                count = count + parseInt(dateValue[1], 0)
              })
              self.wt1 = count
            }
          })
        var startDate1 = moment(new Date()).startOf('year').format('YYYY-MM-DD')
        var u1 = '?metrics=ga:pageviews&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate1 + '&endDate=' + endDate
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u1)
        .then((response) => {
          if (response.data.rows.length !== 0) {
            var count = 0
            response.data.rows.forEach((dateValue) => {
              count = count + parseInt(dateValue[1], 0)
            })
            self.wt2 = count
          }
        })
        var startDate2 = moment(new Date()).add(-1, 'months').startOf('month').format('YYYY-MM-DD')
        var endDate2 = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD')
        var u2 = '?metrics=ga:pageviews&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate2 + '&endDate=' + endDate2
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u2)
        .then((response) => {
          if (response.data.rows.length !== 0) {
            var count = 0
            response.data.rows.forEach((dateValue) => {
              count = count + parseInt(dateValue[1], 0)
            })
            self.wt3 = count
          }
        })
        var endDate3 = moment(new Date()).add(-1, 'years').format('YYYY-MM-DD')
        var startDate3 = moment(new Date()).add(-1, 'years').startOf('year').format('YYYY-MM-DD')
        var u3 = '?metrics=ga:pageviews&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate3 + '&endDate=' + endDate3
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u3)
        .then((response) => {
          if (response.data.rows.length !== 0) {
            var count = 0
            response.data.rows.forEach((dateValue) => {
              count = count + parseInt(dateValue[1], 0)
            })
            self.wt4 = count

            if (self.wt3 === 0) {
              self.p1 = 100
              if (self.p1 >= 0) {
                self.p1c = 'accend'
              }
            } else {
              self.p1 = ((self.wt1 - self.wt3) / self.wt3)
              self.p1 = parseFloat(parseFloat(self.p1) * 100).toFixed(2)
              if (self.p1 >= 0) {
                self.p1c = 'accend'
              }
            }
            if (self.wt4 === 0) {
              self.p2 = 100
              if (self.wt2 >= 0) {
                self.p2c = 'accend'
              }
            } else {
              self.p2 = ((self.wt2 - self.wt4) / self.wt4)
              self.p2 = parseFloat(parseFloat(self.p2) * 100).toFixed(2)
              if (self.p2 >= 0) {
                self.p2c = 'accend'
              }
            }
          }
        })

        var startDate41 = moment(new Date()).add(-1, 'days').subtract(30, 'days').format('YYYY-MM-DD')
        var endDate41 = moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('posts').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (moment.unix(childData.posteddate / 1000).format('YYYY-MM-DD') <= endDate41 && moment.unix(childData.posteddate / 1000).format('YYYY-MM-DD') >= startDate41) {
              c = c + 1
            }
          })
          self.pt1 = c
        })

        var startDate51 = moment(new Date()).startOf('year').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('posts').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (moment.unix(childData.posteddate / 1000).format('YYYY-MM-DD') >= startDate51) {
              c = c + 1
            }
          })
          self.pt2 = c
        })

        var startDate61 = moment(new Date()).add(-1, 'months').startOf('month').format('YYYY-MM-DD')
        var endDate61 = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('posts').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (moment.unix(childData.posteddate / 1000).format('YYYY-MM-DD') <= endDate61 && moment.unix(childData.posteddate / 1000).format('YYYY-MM-DD') >= startDate61) {
              c = c + 1
            }
          })
          self.pt3 = c
        })

        var endDate71 = moment(new Date()).add(-1, 'years').format('YYYY-MM-DD')
        var startDate71 = moment(new Date()).add(-1, 'years').startOf('year').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('posts').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (moment.unix(childData.posteddate / 1000).format('YYYY-MM-DD') <= endDate71 && moment.unix(childData.posteddate / 1000).format('YYYY-MM-DD') >= startDate71) {
              c = c + 1
            }
          })
          self.pt4 = c

          if (self.pt3 === 0) {
            self.pp1 = 100
            if (self.pp1 >= 0) {
              self.pp1c = 'accend'
            }
          } else {
            self.pp1 = ((self.pt1 - self.pt3) / self.pt3)
            self.pp1 = parseFloat(parseFloat(self.pp1) * 100).toFixed(2)
            if (self.pp1 >= 0) {
              self.pp1c = 'accend'
            }
          }
          if (self.pt4 === 0) {
            self.pp2 = 100
            if (self.pp2 >= 0) {
              self.pp2c = 'accend'
            }
          } else {
            self.pp2 = ((self.pt2 - self.pt4) / self.pt4)
            self.pp2 = parseFloat(parseFloat(self.pp2) * 100).toFixed(2)
            if (self.pp2 >= 0) {
              self.pp2c = 'accend'
            }
          }
        })

        var startDate4 = moment(new Date()).add(-1, 'days').subtract(30, 'days').format('YYYY-MM-DD')
        var endDate4 = moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('users').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (childData.createdAt <= endDate4 && childData.createdAt >= startDate4) {
              c = c + 1
            }
          })
          self.nt1 = c
        })

        var startDate5 = moment(new Date()).startOf('year').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('users').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (childData.createdAt >= startDate5) {
              c = c + 1
            }
          })
          self.nt2 = c
        })

        var startDate6 = moment(new Date()).add(-1, 'months').startOf('month').format('YYYY-MM-DD')
        var endDate6 = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('users').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (childData.createdAt <= endDate6 && childData.createdAt >= startDate6) {
              c = c + 1
            }
          })
          self.nt3 = c
        })

        var endDate7 = moment(new Date()).add(-1, 'years').format('YYYY-MM-DD')
        var startDate7 = moment(new Date()).add(-1, 'years').startOf('year').format('YYYY-MM-DD')
        this.$firebase.database().ref().child('users').once('value', function (snapshot) {
          let c = 0
          snapshot.forEach(function (childSnapshot) {
            var childData = childSnapshot.val()

            if (childData.createdAt <= endDate7 && childData.createdAt >= startDate7) {
              c = c + 1
            }
          })
          self.nt4 = c
          if (self.nt3 === 0) {
            self.np1 = 100
            if (self.np1 >= 0) {
              self.np1c = 'accend'
            }
          } else {
            self.np1 = ((self.nt1 - self.nt3) / self.nt3)
            self.np1 = parseFloat(parseFloat(self.np1) * 100).toFixed(2)
            if (self.np1 >= 0) {
              self.np1c = 'accend'
            }
          }
          if (self.nt4 === 0) {
            self.np2 = 100
            if (self.np2 >= 0) {
              self.np2c = 'accend'
            }
          } else {
            self.np2 = ((self.nt2 - self.nt4) / self.nt4)
            self.np2 = parseFloat(parseFloat(self.np2) * 100).toFixed(2)
            if (self.np2 >= 0) {
              self.np2c = 'accend'
            }
          }
        })

        var startDate8 = moment(new Date()).add(-1, 'days').subtract(30, 'days').format('YYYY-MM-DD')
        var endDate8 = moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        var u8 = '?metrics=ga:avgTimeOnPage&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate8 + '&endDate=' + endDate8
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u8)
        .then((response) => {
          if (response.data.rows.length !== 0) {
            var count = 0
            response.data.rows.forEach((dateValue) => {
              count = count + parseInt(dateValue[1], 0)
            })
            if (count === 0) {
              self.tt1 = 0
            } else {
              self.tt1 = (count / response.data.totalResults).toFixed(2)
            }
          }
        })
        var startDate9 = moment(new Date()).startOf('year').format('YYYY-MM-DD')
        var u9 = '?metrics=ga:avgTimeOnPage&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate9 + '&endDate=' + endDate8
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u9)
        .then((response) => {
          if (response.data.rows.length !== 0) {
            var count = 0
            response.data.rows.forEach((dateValue) => {
              count = count + parseInt(dateValue[1], 0)
            })
            if (count === 0) {
              self.tt2 = 0
            } else {
              self.tt2 = (count / response.data.totalResults).toFixed(2)
            }
          }
        })
        var startDate10 = moment(new Date()).add(-1, 'months').startOf('month').format('YYYY-MM-DD')
        var endDate10 = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD')
        var u10 = '?metrics=ga:avgTimeOnPage&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate10 + '&endDate=' + endDate10
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u10)
        .then((response) => {
          if (response.data.rows.length !== 0) {
            var count = 0
            response.data.rows.forEach((dateValue) => {
              count = count + parseInt(dateValue[1], 0)
            })
            if (count === 0) {
              self.tt3 = 0
            } else {
              self.tt3 = (count / response.data.totalResults).toFixed(2)
            }
          }
        })
        var endDate11 = moment(new Date()).add(-1, 'years').format('YYYY-MM-DD')
        var startDate11 = moment(new Date()).add(-1, 'years').startOf('year').format('YYYY-MM-DD')
        var u11 = '?metrics=ga:avgTimeOnPage&dimensions=ga:date&sort=ga:date&maxResults=99999999&startDate=' + startDate11 + '&endDate=' + endDate11
        axios.get('https://us-central1-defense-exchange.cloudfunctions.net/api/exchange/getReports' + u11)
        .then((response) => {
          if (response.data.rows.length !== 0) {
            var count = 0
            response.data.rows.forEach((dateValue) => {
              count = count + parseInt(dateValue[1], 0)
            })

            if (count === 0) {
              self.tt4 = 0
            } else {
              self.tt4 = (count / response.data.totalResults).toFixed(2)
            }
          }

          if (self.tt3 === 0) {
            self.tp1 = 100
            if (self.tp1 >= 0) {
              self.tp1c = 'accend'
            }
          } else {
            self.tp1 = ((self.tt1 - self.tt3) / self.tt3)
            self.tp1 = parseFloat(parseFloat(self.tp1) * 100).toFixed(2)
            if (self.tp1 >= 0) {
              self.np1c = 'accend'
            }
          }
          if (self.tt4 === 0) {
            self.tp2 = 100
            if (self.tp2 >= 0) {
              self.tp2c = 'accend'
            }
          } else {
            self.tp2 = ((self.tt2 - self.tt4) / self.tt4)
            self.tp2 = parseFloat(parseFloat(self.tp2) * 100).toFixed(2)
            if (self.tp2 >= 0) {
              self.tp2c = 'accend'
            }
          }
        })
      }
    },
    computed: {
      styles () {
        return this.$store.getters.getStyles
      }
    },
    mounted () {
      this.loadData()
      const payload = {
        meta: {
          'h1': 'Admin Settings - Home',
          'title': 'Admin Settings - Home',
          'description': 'Admin Settings',
          'keywords': '',
          'requiresAuth': true
        }
      }
      document.title = payload.meta.title
      this.$store.commit('setHeaderInfo', payload)
    }
  }
</script>

<style lang="scss" scoped>
  .dashboard-card_title {
    box-shadow: none;
    padding: 20px;

    .title {
      font-size: 16px !important;
    }
  }

  .number-metrics {
    margin-bottom: 20px;
  }

  img.avatar.img-avatar {
    height: 40px;
  }

  td.listx{
    padding: 5px;
    font-size: 12px;
    font-family: sans-serif;
    width:auto;
  }

  .center {
    text-align:center;
  }

  td.listx img.avatar.img-avatar {
    height: 40px;
    width: 40px;
    border-radius: 5px;
    background: #577194;
  }

  td.listx a {
    text-decoration:none;
    color:#2196F3;
  }

  .btn_head_title .headline{
    font-size:1rem !important;
  }

  .toolbar__content h5{
    font-size:18px !important;
  }

  .btn_head_title{
    padding-bottom:5px;
  }

  .stat_title {
    width: 100%;
    text-align: left;
  }

  .card__title.primary{
    padding-bottom:5px;
  }

  .stat_title > h4 {
    line-height: 15px !important;
    font-weight: 400 !important;
  }

  .metric-key {
    font-size: 0.95em;
    white-space: nowrap;
  }

  .headline {
    display: block;
    font-size: 2.0em !important;
    font-weight: 400 !important;
    margin-top: 4px;
  }

  .decline, .accend {
    display: inline-block;
    border-radius: 3px;
    white-space: nowrap;

    i {
      margin: 0;
      color: #667f8a;
    }
  }

  .decline {
    .mdi-menu-up {
      display: none;
    }
  }

  .accend {
    .mdi-menu-down {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// IndexView.vue?1de516f1